var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMdn = function SvgMdn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 -5 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1704 3.97266H6.66704C4.37517 3.97266 2.5 5.96016 2.5 8.38932V43.7227C2.5 46.1518 4.37517 48.1393 6.66704 48.1393H44.1704C46.4623 48.1393 48.3375 46.1518 48.3375 43.7227V8.38932C48.3375 5.96016 46.4623 3.97266 44.1704 3.97266ZM44.1704 43.7227H6.66704V12.806H44.1704V43.7227Z",
    fill: "#5A23D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9494 17.2266L17.3079 36.4822H15L20.6218 17.2266H22.9494ZM25.0009 17.2266V36.4822H22.9494V17.2266H25.0009ZM32.9503 17.2266L27.3285 36.4822H25.0206L30.6424 17.2266H32.9503ZM35.0018 17.2266V36.4822H32.9503V17.2266H35.0018Z",
    fill: "#5A23D7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMdn);
export { ForwardRef as ReactComponent };
export default "/static/media/mdn.a7389aaa37666c0871e6ab53458961e5.svg";